<div class="maintenance-banner" *ngIf="status">
  <mat-icon class="maintenance-banner__icon">warning</mat-icon>
  <div class="maintenance-banner__text">
    <strong>Tervezett karbantartás:</strong>
    {{ status.message }}
    <span class="maintenance-banner__time">
      {{ status.startTime | date: "yyyy.MM.dd. HH:mm":"Europe/Budapest" }} –
      {{ status.endTime | date: "yyyy.MM.dd. HH:mm":"Europe/Budapest" }}
    </span>
  </div>
</div>
